import { GroupInfo, GroupsInfo, Student } from '@monorepo/golab-generated'

export interface StudentGroupPlaceholderContent {
  contentType: 'studentGroup'
}

export type StudentGroupContent =
  | {
      groupId: string
      isInGroup: true
      members: Student[]
      studentId: string
    }
  | {
      isInGroup: false
      studentId: string
    }

export function createStudentGroupContent(
  groupsInfo: GroupsInfo | undefined,
  studentId: string,
): StudentGroupContent | null {
  if (!groupsInfo?.useCollaboration || !studentId) {
    return null
  }

  const group = findStudentGroup(groupsInfo, studentId)
  if (!group) {
    if (groupsInfo?.unassignedStudents.members.some((member) => member._id === studentId)) {
      return {
        isInGroup: false,
        studentId,
      }
    }
    //student is not assigned or unassigned - error state
    return null
  }

  return {
    groupId: group._id,
    isInGroup: true,
    members: group.members,
    studentId,
  }
}

function findStudentGroup(groupsInfo: GroupsInfo, studentId: string): GroupInfo | null {
  const group = groupsInfo.groups.find((candidate) => candidate.members.some((member) => member._id === studentId))
  return group ?? null
}
